'use strict';

var react = require('react');

const useOnceBeforeRenderingChild = (fn) => {
  const isCalledRef = react.useRef(false);
  if (isCalledRef.current) {
    return;
  }
  fn();
  isCalledRef.current = true;
};

module.exports = useOnceBeforeRenderingChild;
//# sourceMappingURL=useOnceBeforeRenderingChild.cjs.map
